// ProjectGrid.js
// Component for rendering project cards in a grid layout

import React from "react";
import { Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";

/**
 * ProjectGrid Component
 * Renders a grid of project cards with responsive layout
 * 
 * @param {Array} projects - Array of project objects to display
 * @param {string} className - Additional CSS classes
 */
function ProjectGrid({ projects = [], className = "" }) {
  // Handle empty or invalid projects array
  if (!Array.isArray(projects) || projects.length === 0) {
    return (
      <div className={`text-center py-5 ${className}`}>
        <h4 style={{ color: "#623686" }}>No projects found in this category.</h4>
        <p style={{ color: "white", opacity: 0.8 }}>
          Check back later for more exciting projects!
        </p>
      </div>
    );
  }

  return (
    <Row 
      style={{ justifyContent: "center", paddingBottom: "10px" }} 
      className={className}
    >
      {projects.map((project, index) => (
        <Col 
          md={6} 
          lg={4}
          className="project-card mb-4" 
          key={`${project.title}-${index}`}
        >
          <ProjectCard
            imgPath={project.imgPath}
            isBlog={false}
            title={project.title}
            description={project.description}
            technologies={project.technologies}
            ghLink={project.ghLink}
            demoLink={project.demoLink}
          />
        </Col>
      ))}
    </Row>
  );
}

export default ProjectGrid;